import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { markRefundSent } from '../api/financeApi';

// Finance's platform-wide "I actually sent this deposit refund" action (copied into the module).
export default function MarkRefundSentModal({ bookingId, show, onHide, onSent }) {
  const [method, setMethod] = useState('bank_transfer');
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    setMethod('bank_transfer');
    setNotes('');
    setError('');
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const updated = await markRefundSent(bookingId, { method, notes: notes.trim() });
      onSent?.(updated);
    } catch (err) {
      setError(err?.response?.data?.msg || 'Unable to mark this refund as sent.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered fullscreen="sm-down">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Mark deposit refund as sent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="small text-muted">
            Confirms the deposit has actually reached the customer — the order won't show as
            Completed until this is done.
          </p>
          {error && <Alert variant="danger" className="py-2">{error}</Alert>}
          <Form.Group className="mb-3" controlId="refund-sent-method">
            <Form.Label>How was it sent?</Form.Label>
            <Form.Select value={method} onChange={(e) => setMethod(e.target.value)}>
              <option value="bank_transfer">Bank / UPI transfer</option>
              <option value="cash">Cash, handed back in person</option>
            </Form.Select>
          </Form.Group>
          <Form.Group controlId="refund-sent-notes">
            <Form.Label>Notes (optional)</Form.Label>
            <Form.Control as="textarea" rows={2} maxLength={500} value={notes} onChange={(e) => setNotes(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide} disabled={submitting}>Cancel</Button>
          <Button variant="success" type="submit" disabled={submitting}>
            {submitting ? 'Saving…' : 'Confirm refund sent'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
